export default __webpack_public_path__ + "static/media/Sefcon-DS-100-ml-eng.7bc901c1.jpg";